import { render, staticRenderFns } from "./SearchBrowse.vue?vue&type=template&id=7a7bb712&scoped=true"
import script from "./SearchBrowse.vue?vue&type=script&lang=ts"
export * from "./SearchBrowse.vue?vue&type=script&lang=ts"
import style0 from "./SearchBrowse.vue?vue&type=style&index=0&id=7a7bb712&lang=css"
import style1 from "./SearchBrowse.vue?vue&type=style&index=1&id=7a7bb712&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7bb712",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a7bb712')) {
      api.createRecord('7a7bb712', component.options)
    } else {
      api.reload('7a7bb712', component.options)
    }
    module.hot.accept("./SearchBrowse.vue?vue&type=template&id=7a7bb712&scoped=true", function () {
      api.rerender('7a7bb712', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/SearchBrowse.vue"
export default component.exports